{
  "version": 1,
  "asset_id": "75bb9e2c-998f-40ef-82e9-fcfc6a1090dd",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/75bb9e2c-998f-40ef-82e9-fcfc6a1090dd/lecanto-black-shingle-roof-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/75bb9e2c-998f-40ef-82e9-fcfc6a1090dd/lecanto-black-shingle-roof-480w.avif",
  "original_filename": "lecanto-black-shingle-roof-480w.avif",
  "size": 26437,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
